import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock } from "vue"

const _hoisted_1 = ["src"]
const _hoisted_2 = { class: "break-words" }
const _hoisted_3 = { class: "text-gray-400 break-words" }
const _hoisted_4 = { class: "flex gap-1 p-1" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Tag = _resolveComponent("Tag")!
  const _component_Card = _resolveComponent("Card", true)!

  return (_openBlock(), _createBlock(_component_Card, { class: "overflow-hidden h-max w-full" }, {
    header: _withCtx(() => [
      _createElementVNode("img", {
        src: _ctx.thumbnail || _ctx.emptyImg,
        onError: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.imgDefaultError && _ctx.imgDefaultError(...args))),
        class: "object-cover",
        style: {"height":"13rem"},
        loading: "lazy"
      }, null, 40, _hoisted_1)
    ]),
    title: _withCtx(() => [
      _createElementVNode("p", _hoisted_2, _toDisplayString(_ctx.title ||
          _ctx.$t("labels.generic", { pt: "Nome do curso", en: "Course name" })), 1)
    ]),
    subtitle: _withCtx(() => [
      _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.description ||
          _ctx.$t("labels.generic", {
            pt: "Resumo do curso...",
            en: "Course description...",
          })), 1)
    ]),
    content: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(`overflow-clip hover:overflow-auto scroll-style w-full ${
          _ctx.categories.length !== 0 ? 'h-12' : 'h-full'
        }`)
      }, [
        _createElementVNode("div", _hoisted_4, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.categories, (categorie, i) => {
            return (_openBlock(), _createElementBlock("div", { key: i }, [
              _createVNode(_component_Tag, {
                class: "w-max select-none btn-primary",
                value: categorie?.name,
                tabindex: "0"
              }, null, 8, ["value"])
            ]))
          }), 128))
        ])
      ], 2)
    ]),
    _: 1
  }))
}